import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import uniqid from 'uniqid'

import InputControlsUI from './InputControlsUI'

const InputControls = ({
  injectType,
  type,
  className,
  label,
  labelLeft,
  value,
  onChange,
  color,
  loading,
  disabled,
  disabledMessage
}) => {
  const [valueInner, setValueInner] = useState(null)
  const [defaultValue, setDefaultValue] = useState(false)
  const [isOpenDisabledModal, setIsOpenDisabledModal] = useState(false)

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) setDefaultValue(value)

    return () => isSubscribed = false
  }, [value])

  useEffect(() => {
    let isSubscribed = true

    isSubscribed && onChange && valueInner !== null && onChange(valueInner)

    return () => isSubscribed = false
  }, [valueInner])

  const onChangeInner = ({ value }) => {
    if (disabled || loading) {
      if (disabledMessage) toggleDisabledModal()
      return
    }

    if (injectType === 'external') onChange(value)
    if (injectType === 'internal') setValueInner(value)
  }

  const toggleDisabledModal = () => setIsOpenDisabledModal(!isOpenDisabledModal)

  return (
    <InputControlsUI
      id={uniqid()}
      type={type}
      className={className}
      label={label}
      labelLeft={labelLeft}
      value={injectType === 'external'
        ? value
        : valueInner === null ? defaultValue : valueInner
      }
      onChange={onChangeInner}
      color={color}
      loading={loading}
      disabled={disabled}
      isOpenDisabledModal={isOpenDisabledModal}
      toggleDisabledModal={toggleDisabledModal}
      disabledMessage={disabledMessage}
    />
  )
}

InputControls.defaultProps = {
  injectType: 'internal',
  type: 'switch',
  className: '',
  label: '',
  labelLeft: '',
  value: false,
  onChange: null,
  color: 'primary',
  loading: false,
  disabled: false,
  disabledMessage: ''
}

InputControls.propTypes  = {
  injectType: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  labelLeft: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string
}

export default InputControls
